module.exports = __webpack_public_path__ + "img/arrows-minimize.2ca3ae0f.svg";